import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { cn } from "@/lib/utils";

interface PhoneInputProps {
  value?: string;
  onChange?: (value: string | undefined) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  error?: boolean;
}

export function PhoneNumberInput({ 
  value, 
  onChange, 
  placeholder = "Enter phone number",
  disabled = false,
  className,
  error = false
}: PhoneInputProps) {
  return (
    <div className={cn("phone-input-wrapper", className)}>
      <PhoneInput
        international
        countryCallingCodeEditable={false}
        defaultCountry="IL"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={cn("custom-phone-input", error && "error")}
      />
    </div>
  );
} 